import { createAsyncThunk } from "@reduxjs/toolkit";
import request from "../../../../service";
import { IErrorResponse, IRootState } from "../../../../types";
import {
    deletedCompetences,
    deletedCompetencesSettings,
    deletedRestoreCompetences,
    deletedRestoreCompetencesSettings,
    setCompetences,
    setCompetencesRestore,
    setCompetencesSettings,
    setCompetencesSettingsRestore,
    updateCompetences,
    updateCompetencesSettings,
} from "./competencesSlice";
import {
    ICompetencesCreate,
    ICompetencesPayload,
    ICompetencesSettingsCreate,
    ICompetencesSettingsPayload,
} from "../types";

const GetCompetences = createAsyncThunk("get/competencies", async (_, { dispatch, rejectWithValue }) => {
    try {
        const response = await request.get("competences");
        dispatch(setCompetences(response.data));
        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const SetCompetences = createAsyncThunk(
    "create/competencies",
    async (data: ICompetencesCreate, { rejectWithValue }) => {
        try {
            const response = await request.post("/competences", data);
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);
const EditCompetences = createAsyncThunk(
    "edit/competences",
    async (data: ICompetencesPayload, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.put(`/competences/${data.id}`, data);
            dispatch(updateCompetences(data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);
const DeleteCompetences = createAsyncThunk("delete/competences", async (id: number, { rejectWithValue, dispatch }) => {
    try {
        const response = await request.delete(`/competences/${id}`);
        dispatch(deletedCompetences(id));
        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const GetDeleteCompetences = createAsyncThunk("get/delete/competences", async (_, { dispatch, rejectWithValue }) => {
    try {
        const response = await request.get(`/competences/deleted-items`);
        dispatch(setCompetencesRestore(response.data));
        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const RestoreDeleteCompetences = createAsyncThunk(
    "restore/competences",
    async (id: number, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.post(`/competences/restore/${id}`);

            dispatch(deletedRestoreCompetences(id));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetCompetencesSettings = createAsyncThunk(
    "get/competencies/settings",
    async (_, { dispatch, rejectWithValue, getState }) => {
        try {
            const response = await request.get("competence-settings");
            const lang = getState() as IRootState;
            const defaultLanguage = lang.languages.defaultLanguage;

            dispatch(setCompetencesSettings({ data: response.data, defaultLanguage }));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const EditCompetencesSettings = createAsyncThunk(
    "edit/competences/settings",
    async (data: ICompetencesSettingsPayload, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.put(`/competence-settings/${data.id}`, data);
            dispatch(updateCompetencesSettings(data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;

            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);
const SetCompetencesSettings = createAsyncThunk(
    "create/competencies/settings",
    async (data: ICompetencesSettingsCreate, { rejectWithValue }) => {
        try {
            const response = await request.post("/competence-settings", data);

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const DeleteCompetencesSettings = createAsyncThunk(
    "delete/competences/settings",
    async (id: number, { rejectWithValue, dispatch }) => {
        try {
            const response = await request.delete(`/competence-settings/${id}`);
            dispatch(deletedCompetencesSettings(id));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetDeleteCompetencesSettings = createAsyncThunk(
    "get/delete/competences/settings",
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.get(`/competence-settings/deleted-items`);

            dispatch(setCompetencesSettingsRestore(response.data));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);
const RestoreDeleteCompetencesSettings = createAsyncThunk(
    "restore/competences/settings",
    async (id: number, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.post(`/competence-settings/restore/${id}`);

            dispatch(deletedRestoreCompetencesSettings(id));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

export {
    GetCompetences,
    GetCompetencesSettings,
    SetCompetences,
    EditCompetences,
    DeleteCompetences,
    GetDeleteCompetences,
    EditCompetencesSettings,
    SetCompetencesSettings,
    DeleteCompetencesSettings,
    RestoreDeleteCompetences,
    GetDeleteCompetencesSettings,
    RestoreDeleteCompetencesSettings,
};
